module.exports = __webpack_public_path__ + "static/media/feishu_app.ab438783.png";